import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ChatResponse, InformacaoUtilRequest } from 'src/models/interfaces/chatbot/chatbot.interface';
import { environment } from 'src/environments/environment';
import { SKIP_ERROR_INTERCEPTOR } from 'src/app/interceptor/error.interceptor';
import { LOADING_INSTANCE } from 'src/app/interceptor/network.interceptor';
import { ChatbotLoadingKeys } from 'src/models/keys/chatbot/chatbot.keys';

@Injectable({
  providedIn: 'root'
})
export class ChatApiService {
  private apiUrl = `${environment.apiUrl}/api/v1/chat/enviarMensagem`;
  private informacaoUtilUrl = `${environment.apiUrl}/api/v1/chat/informacaoUtil`;
  private headers = new HttpHeaders({ ID_USUARIO_SITE_SPE: localStorage.getItem('idCliente')! });
  constructor(private http: HttpClient) {}

  sendMessage(mensagem: string): Observable<ChatResponse> {
    return this.http.post<ChatResponse>(
      this.apiUrl,
      { mensagem },
      {
        headers: this.headers,
        context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true).set(LOADING_INSTANCE, ChatbotLoadingKeys.Default)
      }
    );
  }

  informacaoUtil(idMessage: string): Observable<unknown> {
    return this.atualizarInformacaoUtil(idMessage, true);
  }

  informacaoNaoUtil(idMessage: string): Observable<unknown> {
    return this.atualizarInformacaoUtil(idMessage, false);
  }

  private atualizarInformacaoUtil(idMessage: string, informacaoUtil: boolean): Observable<unknown> {
    const body: InformacaoUtilRequest = { idMessage, informacaoUtil };
    return this.http.put(
      this.informacaoUtilUrl,
      body,
      {
        headers: this.headers,
        context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
      }
    );
  }
}
